export const TOAST_LIFE_TIME_MS = 3200

/**
 * The PrimeVue toast service, for callers that live outside a component and
 * cannot call useToast() themselves — useApi() is the one that does.
 *
 * Assigned once by app.vue. Named `globalToast` rather than `toast` so that a
 * component's own `const toast = useToast()` cannot silently shadow it.
 */
export const globalToast = ref<ReturnType<typeof useToast>>()

export const toastErrorMessage = ref('')
